import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import QACommentEntity from "../../../../domain/entities/qa_comment.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const addCommentApiImpl = async ({ employeeID, comment }: { employeeID: string; comment: QACommentEntity; }): Promise<Either<ErrorEntity, QACommentEntity>> => {
    try {
        const relativeUrl = `/comment`;
        const response = await di.get<HostApi>(HostApiName).post(relativeUrl, {
            "human_agent_id": employeeID,
            "comment": comment.comment,
        }, {
            contentType: 'application/json',
        });
        if (response.comment != undefined) {
            return right(comment);
        } else {
            return left({});
        }
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default addCommentApiImpl;